import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import {Urls} from "../../constants/mep/mep-emission-target-config.constants";
import { MepCreateOrUpdateEmissionTypeConfigRequest, MepCreateOrUpdateEmissionTypeConfigResponse, MepDeleteEmissionTypeConfigRequest, MepDeleteEmissionTypeConfigResponse, MepGetPortEmissionTargetYearsResponse as MepGetPortEmissionTargetInitDataResponse, MepGetPortEmissionTypesConfigDetailResponse, MepGetPortEmissionTypesConfigResponse, MepUpdateLongTermYearConfigRequest, MepUpdateLongTermYearConfigResponse } from "../../models/mep/mep-emission-target-config.models";

@autoinject()
export class MepEmissionTargetConfigService {
    
    constructor(private requestClient: RequestClientService) {
    }
    
    public getPortEmissionTypesConfig(portId: number, year: number) : Promise<MepGetPortEmissionTypesConfigResponse> {
        return this.requestClient.get<MepGetPortEmissionTypesConfigResponse>(`${Urls.GetPortEmissionTypesConfig}`, { portId: portId, year: year  });
    }

    public getPortEmissionTypesConfigDetail(portId: number, emissionTypeId, year: number, overriddenRelativeTargetBaseYear: number) : Promise<MepGetPortEmissionTypesConfigDetailResponse> {
        return this.requestClient.get<MepGetPortEmissionTypesConfigDetailResponse>(`${Urls.GetPortEmissionTypesConfigDetail}`, { portId: portId, emissionTypeId: emissionTypeId, year: year, overriddenRelativeTargetBaseYear: overriddenRelativeTargetBaseYear });
    }

    public getPortEmissionTargetInitData(portId: number, loadTargetYears: boolean) : Promise<MepGetPortEmissionTargetInitDataResponse> {
        return this.requestClient.get<MepGetPortEmissionTargetInitDataResponse>(`${Urls.GetPortEmissionTargetInitData}`, { portId: portId, loadTargetYears: loadTargetYears });
    }

    public createOrUpdateEmissionTypeConfig(request: MepCreateOrUpdateEmissionTypeConfigRequest) : Promise<MepCreateOrUpdateEmissionTypeConfigResponse> {
        return this.requestClient.post<MepCreateOrUpdateEmissionTypeConfigResponse>(`${Urls.CreateOrUpdateEmissionTypeConfig}`, {}, request);
    }

    public deleteEmissionTypeConfig(request: MepDeleteEmissionTypeConfigRequest) : Promise<MepDeleteEmissionTypeConfigResponse> {
        return this.requestClient.post<MepDeleteEmissionTypeConfigResponse>(`${Urls.DeleteEmissionTypeConfig}`, {}, request);
    }

    public updateLongTermYearConfig(request: MepUpdateLongTermYearConfigRequest) : Promise<MepUpdateLongTermYearConfigResponse> {
        return this.requestClient.post<MepUpdateLongTermYearConfigResponse>(`${Urls.UpdateLongTermYearConfig}`, {}, request);
    }
    
}
